import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import NotificationBell from "../components/NotificationBell";

const ROLES = {
  1: "Super Admin",
  2: "Admin",
  3: "Manager",
  4: "Team Lead",
  5: "Agent",
  6: "Accounts",
  7: "Designer",
};

export default function Topbar({ onLogout, onMenuClick }) {
  const navigate = useNavigate();
  const [username, setUsername] = useState("");
  const [initials, setInitials] = useState("");
  const [isSuperAdmin, setIsSuperAdmin] = useState(false);

  useEffect(() => {
    const user = localStorage.getItem("admin_user");
    if (user) {
      const parsedUser = JSON.parse(user);
      const fullName = `${parsedUser.first_name} ${parsedUser.last_name}`;
      const roleName = ROLES[parsedUser.role_id] || "Unknown";
      setUsername(`${fullName} (${roleName})`);
      setInitials(
        `${(parsedUser.first_name || "").charAt(0)}${(parsedUser.last_name || "").charAt(0)}`.toUpperCase() || "A"
      );
      setIsSuperAdmin(Number(parsedUser.role_id) === 1);
    }
  }, []);

  return (
    <header className="h-14 border-b bg-white flex items-center justify-between px-3 sm:px-6 gap-2">
      <div className="flex items-center gap-2 min-w-0">
        <button
          onClick={onMenuClick}
          className="lg:hidden shrink-0 rounded-lg p-2 hover:bg-gray-100"
          aria-label="Open menu"
        >
          ☰
        </button>
        <div className="text-sm text-gray-600 truncate">
          <span className="hidden sm:inline">Admin Panel - </span>
          {username}
        </div>
      </div>
      <div className="flex items-center gap-2 sm:gap-3 shrink-0">
        {isSuperAdmin && <NotificationBell />}
        <button
          onClick={() => navigate("/admin/my-profile")}
          aria-label="My Profile"
          title="My Profile"
          className="h-9 w-9 shrink-0 rounded-full bg-gradient-to-br from-blue-500 to-indigo-600 text-white text-sm font-semibold flex items-center justify-center shadow-sm ring-2 ring-white hover:ring-blue-200 hover:shadow-md transition-all"
        >
          {initials}
        </button>
        <button
          onClick={onLogout}
          className="text-sm font-semibold px-3 sm:px-4 py-2 rounded-lg border hover:bg-gray-50"
        >
          Logout
        </button>
      </div>
    </header>
  );
}
